export class HardCopyConstants{
  public static readonly HardCopyActivity_Created_Success:string = "Hardcopy Activity Created Successfully";
  public static readonly HardCopyActivity_Updated_Success:string = "Hardcopy Activity Updated Successfully";
  public static readonly HardCopyActivity_Deleted_Success:string = "Hardcopy Activity Deleted Successfully";
  public static readonly HardCopyActivity_Completed_Success:string = "Hardcopy Activity Completed Successfully";
  public static readonly Severity_Info:string = "info";
  public static readonly CreateHCActivityHeader:string="Create Hardcopy Activity";
  public static readonly EditHCActivityHeader:string="Edit Hardcopy Activity";

  
  // confirmation Messages
  public static readonly HardCopyActivity_Slider_Confirmation_Header: string = "Confirmation";
  public static readonly HardCopyActivity_Confirmation_Text: string = "Any unsaved change will be lost when closing the screen. Do you want to continue?";

  public static readonly effectiveStatus:number=6;

  // Error messages text
  public static readonly HardCopyActivity_Activity_Required: string = "Activity is required.";
  public static readonly HardCopyActivity_Location_Required: string = "Location is required.";
  public static readonly HardCopyActivity_StorageLocation_Required: string = "Stroage Location is required.";
  public static readonly HardCopyActivity_Copies_Required: string = "Copies is required.";
  public static readonly HardCopyActivity_AssignedUser_Required: string = "Assigned User is required.";

  public static readonly HardCopyActivity_Reason_Required: string = "Reason is required.";

  public static readonly HardCopyActivity_Activity_Status_Done:string="Done";
  public static readonly HardCopyActivity_Activity_Status_Scheduled:string="Scheduled";
  public static readonly HardCopyActivity_Activity_Status_Pending:string="Pending";
  public static readonly HardCopyActivity_Activity_Activity_Remove:string="Remove";

  public static readonly HardCopyActivity_Activity_Remove:number=2;
  public static readonly HardCopyActivity_Activity_Activity_Print:number=1;
  
  public static readonly HardCopyActivity_ActivityStatus_Scheduled:number = 0;
  public static readonly HardCopyActivity_ActivityStatus_Pending:number = 1;
  public static readonly HardCopyActivity_ActivityStatus_Done:number = 2;

}
